export default class SpaceLiveClientUrl {
    /**
     * @type {string}
     * @memberof SpaceLiveClientUrl
     * @name 直播链接
     */
    public url: string
    /**
     * @type {boolean}
     * @memberof SpaceLiveClientUrl
     * @name 是否存在有效直播链接
     */
    public hasLiveUrl: boolean
    /**
     * @type {string}
     * @memberof SpaceLiveClientUrl
     * @name REGISTERED(1, "已注册"),
            UN_REGISTER(2, "未注册"),
            ABNORMAL(3, "异常")
     */
    public liveUserExtraState: string
    constructor({
        url = '',
        hasLiveUrl = true,
        liveUserExtraState = ''
    } = {}) {
        this.url = url
        this.hasLiveUrl = hasLiveUrl
        this.liveUserExtraState = liveUserExtraState
    }
}